import {API_URL_STORE} from "./urls";

const getApiLiveness = () => {
  return window.axios

    .get(API_URL_STORE + "liveness")

    .then((response) => {
      console.log();

      return response.data;
    })

    .catch((error) => {
      throw error;
    });
};

export { getApiLiveness };
